import React from 'react';

import PropTypes from 'prop-types';

import {
    Content,
    ContentSection,
    MarkdownContent,
    Typography,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import styles from './InfoSection.scss';

function InfoSection(props) {
    const {
        i18nMoment,
        i18nMoney,
        t,
        id,
        textTranslationKey,
        infoTitle,
        infoText,
        className,
        layoutClassName,
        namespace,
        useAccordionComponent,
        metrics,
        isOpen,
    } = props;
    const {
        minUsdLonghaul,
        minUsdShorthaul,
        minUsdMediumhaul,
        minUsdOutofstate,
        cheapestPrice,
        cheapestAvgPrice,
        savingsPriceUsd,
        avgPrice,
        maxPrice,
        minPrice,
        highPriceMonth,
        highPriceMonthPrice,
        lowPriceMonth,
        lowPriceMonthPrice,
        lowUpcomingMonthPrice,
        highUpcomingMonthPrice,
        lowUpcomingMonthPriceDate,
        lowUpcomingWeekDate,
        highUpcomingWeekDate,
        lowUpcomingWeekPrice,
        highUpcomingWeekPrice,
        commonMonth,
        commonWeekPrice,
        commonMonthPrice,
    } = metrics;

    if (!infoText || !infoTitle) {
        return null;
    }

    const moneyOpts = {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    };

    const translationReplacements = {
        minUsdLonghaul: minUsdLonghaul
            ? i18nMoney(minUsdLonghaul).format(moneyOpts)
            : '',
        minUsdShorthaul: minUsdShorthaul
            ? i18nMoney(minUsdShorthaul).format(moneyOpts)
            : '',
        minUsdMediumhaul: minUsdMediumhaul
            ? i18nMoney(minUsdMediumhaul).format(moneyOpts)
            : '',
        minUsdOutofstate: minUsdOutofstate
            ? i18nMoney(minUsdOutofstate).format(moneyOpts)
            : '',
        avgCheapPriceUSD: cheapestAvgPrice
            ? i18nMoney(cheapestAvgPrice).format()
            : '',
        price: cheapestPrice
            ? i18nMoney(cheapestPrice).format()
            : '',
        savingsPrice: savingsPriceUsd
            ? i18nMoney(savingsPriceUsd).format()
            : '',
        avgPrice: avgPrice
            ? i18nMoney(avgPrice).format()
            : '',
        maxPrice: maxPrice
            ? i18nMoney(maxPrice).format()
            : '',
        minPrice: minPrice
            ? i18nMoney(minPrice).format()
            : '',
        lowUpcomingWeekPrice: lowUpcomingWeekPrice
            ? i18nMoney(lowUpcomingWeekPrice).format(moneyOpts)
            : null,
        lowUpcomingWeekDate: lowUpcomingWeekDate
            ? i18nMoment(lowUpcomingWeekDate).format('LL')
            : null,
        lowUpcomingMonthPriceDate: lowUpcomingMonthPriceDate
            ? i18nMoment(lowUpcomingMonthPriceDate).format('LL')
            : null,
        lowUpcomingMonthPrice: lowUpcomingMonthPrice
            ? i18nMoney(lowUpcomingMonthPrice).format(moneyOpts)
            : null,
        lowPriceMonthPrice: lowPriceMonthPrice
            ? i18nMoney(lowPriceMonthPrice).format(moneyOpts)
            : null,
        lowPriceMonth: lowPriceMonth
            ? i18nMoment(lowPriceMonth, 'M').format('MMMM')
            : null,
        highUpcomingWeekPrice: highUpcomingWeekPrice
            ? i18nMoney(highUpcomingWeekPrice).format(moneyOpts)
            : null,
        highUpcomingWeekDate: highUpcomingWeekDate
            ? i18nMoment(highUpcomingWeekDate).format('LL')
            : null,
        highUpcomingMonthPrice: highUpcomingMonthPrice
            ? i18nMoney(highUpcomingMonthPrice).format(moneyOpts)
            : null,
        highPriceMonthPrice: highPriceMonthPrice
            ? i18nMoney(highPriceMonthPrice).format(moneyOpts)
            : null,
        highPriceMonth: highPriceMonth
            ? i18nMoment(highPriceMonth, 'M').format('MMMM')
            : null,
        commonWeekPrice: commonWeekPrice
            ? i18nMoney(commonWeekPrice).format(moneyOpts)
            : null,
        commonMonthPrice: commonMonthPrice
            ? i18nMoney(commonMonthPrice).format(moneyOpts)
            : null,
        commonMonth: commonMonth
            ? i18nMoment(commonMonth, 'M').format('MMMM')
            : null,
    };

    return (
        <ContentSection
            className={className}
            id={`cg-carrier-info-${id}`}
            isCollapsable={useAccordionComponent}
            isOpen={isOpen}
            layoutClassName={layoutClassName}
            title={(
                <Typography
                    component="h3"
                    variant="h6"
                >
                    {infoTitle}
                </Typography>
            )}
            useAccordionComponent={useAccordionComponent}
        >
            <Content>
                <MarkdownContent className={styles.description}>
                    {namespace
                        ? t(`${namespace}:${textTranslationKey}`, translationReplacements)
                        : Object.entries(translationReplacements)
                            .reduce((text, [key, value]) => text.replace(`__${key}__`, value), infoText)
                    }
                </MarkdownContent>
            </Content>
        </ContentSection>
    );
}

InfoSection.propTypes = {
    id: PropTypes.string,
    infoTitle: PropTypes.string,
    infoText: PropTypes.string,
    className: PropTypes.string,
    layoutClassName: PropTypes.string,
    textTranslationKey: PropTypes.string,
    namespace: PropTypes.string,
    useAccordionComponent: PropTypes.bool,
    metrics: PropTypes.shape({
        minUsdLonghaul: PropTypes.number,
        minUsdShorthaul: PropTypes.number,
        minUsdMediumhaul: PropTypes.number,
        minUsdOutofstate: PropTypes.number,
    }),
};

InfoSection.defaultProps = {
    id: '',
    infoTitle: '',
    infoText: '',
    className: '',
    layoutClassName: '',
    textTranslationKey: '',
    namespace: '',
    useAccordionComponent: true,
    metrics: {},
};

export { InfoSection };
export default localize(InfoSection);
